import React, { PureComponent } from "react";
import ReactDOM from "react-dom";
import { branch } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";
import _ from "lodash";
import Modal from "react-responsive-modal";
import autoBind from "react-autobind";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";

import PlayerItemWrapper from "../playerItemComponents/PlayerItemWrapper";
import * as Utils from "../../utils/utils";
import Breadcrumb from "../nav/Breadcrumb";
import BreadcrumbDialog from "../nav/BreadcrumbDialog";
// import QuickToolbar from "../shared/QuickToolbar";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import * as playerActions from "../../actions/playerActions";
import RelatedItem from "../shared/button/RelatedItem";

class ItemModal extends PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	handleShowHideNavigationView(show) {
		this.props.dispatch(
			playerActions.showHideNavigationView,
			show
		);
	}
	
	render() {
		let targetObj = _.isNumber(this.props.listIndex) ? this.props : this.props.itemModalConfig;

		if (!targetObj || !_.isNumber(targetObj.listIndex) || !_.isNumber(targetObj.sectionIndex) || !_.isNumber(targetObj.itemIndex) || (targetObj && targetObj.useSelectedItem)) {
			// Ultimate fallback
			targetObj = this.props.selectedItem;
		}
		//console.log("SHOW ITEM MODAL render", targetObj, this.props);
		
		if (!targetObj) {
			return null;
		}
		const { topMargin, orientation, itemModalConfig = {suppressNav:false, nav:true}, currentActivity } = this.props;
		const { suppressNav, nav } = itemModalConfig;
		let _suppressNav = suppressNav === true || nav === false;
		const { listIndex, sectionIndex, itemIndex } = targetObj;
		const item = Utils.getItem(this.context.tree, listIndex, sectionIndex, itemIndex);

		const isLandscape = orientation === "landscape";

		let relatedItems = [];
		if (currentActivity && currentActivity.hasOwnProperty("relatedItems") && !_.isEmpty(currentActivity.relatedItems) && _.isArray(currentActivity.relatedItems)) {
			let selectedListIndex = listIndex;
			let selectedSectionIndex = sectionIndex;
			let selectedItemIndex = itemIndex;


			let relatedItemsMap = {};
			currentActivity.relatedItems.forEach(relatedItem => {
				const { id } = relatedItem;
				relatedItemsMap[id] = relatedItem;
			});

			let currentList;
			if (selectedListIndex !== null) {
				currentList = _.get(currentActivity, `children.${selectedListIndex}`, null);
			}
			let i = 0;
			if (currentList && currentList.hasOwnProperty("relatedItemRefs") && _.isString(currentList.relatedItemRefs) && currentList.relatedItemRefs !== "") {
				const relatedItemIds = currentList.relatedItemRefs.split(",");
				relatedItemIds.forEach(id => {
					i++;
					if (relatedItemsMap[id]) {
						const relatedItem = relatedItemsMap[id];
						if (relatedItem) {
							const linkUrl = relatedItem.linkUrl;

							// JJB Hardwiring index to 0 may be problem if 0 is not visible
							relatedItems.push(
								<div key={"relatedItemList-" + i} style={{ padding: 10 }}>
									<RelatedItem onClick={() => {
										this.props.dispatch(playerActions.linkUrl, linkUrl);
									}} relatedItem={relatedItem} />
								</div>
							);
						}
					}
				});
			}

			let currentSection;
			if (selectedListIndex !== null && selectedSectionIndex !== null) {
				currentSection = _.get(currentActivity, `children.${selectedListIndex}.children.${selectedSectionIndex}`, null);
			}

			if (currentSection && currentSection.hasOwnProperty("relatedItemRefs") && _.isString(currentSection.relatedItemRefs) && currentSection.relatedItemRefs !== "") {
				const relatedItemIds = currentSection.relatedItemRefs.split(",");
				relatedItemIds.forEach(id => {
					i++;
					if (relatedItemsMap[id]) {
						const relatedItem = relatedItemsMap[id];
						if (relatedItem) {
							const linkUrl = relatedItem.linkUrl;

							// JJB Hardwiring index to 0 may be problem if 0 is not visible
							relatedItems.push(
								<div key={"relatedItemList-" + i} style={{ padding: 10 }}>
									<RelatedItem onClick={() => {
										this.props.dispatch(playerActions.linkUrl, linkUrl);
									}} relatedItem={relatedItem} />
								</div>
							);
						}
					}
				});
			}

			let currentItem;
			if (selectedListIndex !== null && selectedSectionIndex !== null && selectedItemIndex !== null) {
				currentItem = _.get(currentActivity, `children.${selectedListIndex}.children.${selectedSectionIndex}.children.${selectedItemIndex}`, null);
			}

			if (currentItem && currentItem.hasOwnProperty("relatedItemRefs") && _.isString(currentItem.relatedItemRefs) && currentItem.relatedItemRefs !== "") {
				const relatedItemIds = currentItem.relatedItemRefs.split(",");
				relatedItemIds.forEach(id => {
					i++;
					if (relatedItemsMap[id]) {
						const relatedItem = relatedItemsMap[id];
						if (relatedItem) {
							const linkUrl = relatedItem.linkUrl;

							// JJB Hardwiring index to 0 may be problem if 0 is not visible
							relatedItems.push(
								<div key={"relatedItemList-" + i} style={{ padding: 10 }}>
									<RelatedItem onClick={() => {
										this.props.dispatch(playerActions.linkUrl, linkUrl);
									}} relatedItem={relatedItem} />
								</div>
							);
						}
					}
				});
			}



		}

		const itemWrapperStyles = _.cloneDeep(isLandscape ? styles.viewWrapperLandscape : styles.viewWrapper);
		if (relatedItems.length > 0) {
			itemWrapperStyles.height = "100%";
		}

		const itemWrapper = <div style={itemWrapperStyles}>
			<BreadcrumbDialog />
			<div style={styles.itemScrollContainer}>{
				<PlayerItemWrapper ignoreVisibility key={"list" + listIndex + "section" + sectionIndex + "item" + itemIndex} listIndex={listIndex} sectionIndex={sectionIndex} itemIndex={itemIndex} item={item} fullScreen suppressNav={true} activity={this.props.activity} />
			}</div>
		</div>;

		return ReactDOM.createPortal(
			<ReactCSSTransitionGroup
				transitionName="fade">
				{this.props.isOpen &&
					<Modal classNames={{
					overlay: "ambifi-web-player",
					modal: "player-comments-modal"
				}}
					open={this.props.isOpen}
				showCloseIcon={false}
					onClose={() => { }}>

					<div style={_.assign({}, styles.itemModal, { top: topMargin ? 85 : 0, bottom: 0 })}>
						<Breadcrumb disableNav={_suppressNav} />
						{relatedItems.length === 0 && itemWrapper}
						{relatedItems.length > 0 &&
							<div style={_.assign({}, isLandscape ? styles.viewWrapperLandscape : styles.viewWrapper, { display: "flex" })}>
								{itemWrapper}
								<div style={{ flex: 1, backgroundColor: "white", display: "flex", flexDirection: "column" }}>
									<div style={{ flex: 0, color: "black", paddingTop: 10, paddingLeft: 10, paddingRight: 10, fontWeight: "bold" }}>RELATED</div>
									<div style={{ flex: 1, overflow: "auto" }}>
										{relatedItems}
									</div>
								</div>
							</div>
						}
						<div style={styles.goBackButton}>
							<div style={{ display: "flex", width: "100%", height: "100%", alignItems: "center", justifyContent: "center", flexDirection: "row", fontSize: 20, color: "white", cursor: "pointer" }} onClick={(e) => { this.props.onClickClose(e); }}><FontAwesomeIcon icon={"chevron-down"} style={{ marginLeft: 10, fontSize: 20 }} />&nbsp;GO BACK TO NORMAL VIEW</div>
						</div>
						{/* <QuickToolbar backgroundColor="rgb(37, 37, 37)" showClock={true} showSaveActions={true} showSideMenuOpen sideMenuOpenAction={() => this.handleShowHideNavigationView(true)} /> */}
					</div>
				</Modal>
				}
			</ReactCSSTransitionGroup>, document.body);
	}
}

/*
{relatedItems.length > 0 &&
							<div style={{ flex: 1, backgroundColor: "white", display: "flex", flexDirection: "column" }}>
								<div style={{ flex: 0, color: "black", paddingTop: 10, paddingLeft: 10, paddingRight: 10, fontWeight: "bold" }}>RELATED</div>
								<div style={{ flex: 1, overflow: "auto"}}>
									{relatedItems}
								</div>
							</div>
						}
*/

const styles = {
	itemModal: {
		//...StyleSheet.absoluteFill,
		backgroundColor: "#D0D0D0",
		zIndex: 2,
		height: "100%"
	},
	itemContentContainer: {
		justifyContent: "center",
		alignItems: "center",
		width: "100%",
		height: "100%",
		flex: 1,
		display: "flex"
	},
	itemScrollContainer: {
		width: "100%",
		height: "100%"
	},
	viewWrapper: {
		width: "100%",
		height: "calc(100% - 120px)",
		position:"relative"
	},
	viewWrapperLandscape: {
		width: "100%",
		height: "calc(100% - 120px)",
		flexDirection: "row",
		display: "flex",
		position: "relative"
	},
	relatedView: {

	},
	relatedViewLandscape: {

	},
	goBackButton: { display: "flex", justifyContent: "center", height: "80px", alignItems: "center", backgroundColor: "#888888" }
};

ItemModal.contextTypes = {
	tree: PropTypes.baobab
};
export default branch({
	children:["activity","children"],
	selectedItem: ["activity", "selected"],
	itemModalConfig: ["appState", "itemModal"],
	activity: ["activity"]
}, ItemModal);
